import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import PropTypes from 'prop-types';

const contactButton = {
    transformOrigin: 'top left',
    transform: 'rotate(-90deg)',
    left: '-10px',
    top: '60%',
};

const contactButtonMobile = {
    right: '30px',
    top: '0px',
};

const showFullButton = (element) => {
    element.target.style.left = '0px'; // eslint-disable-line no-param-reassign
};

const hideFullButton = (element) => {
    element.target.style.left = '-10px'; // eslint-disable-line no-param-reassign
};

const IssueFloatingButton = () => (
    <>
        <button
            className="fixed z-50 text-white font-semibold text-xl bg-green-500 px-6 py-2 cursor-pointer hover:bg-green-700 hidden md:block focus:outline-none"
            style={contactButton}
            onMouseOver={showFullButton}
            onMouseLeave={hideFullButton}
            data-testid="report-an-issue-btn"
        >
            <span className="block text-2xl inline-block align-bottom pr-2">
                <FaEnvelope />
            </span>
            Report an Issue
        </button>

        <button
            className="absolute z-50 text-white font-semibold text-3xl bg-green-500 px-3 py-2 cursor-pointer hover:bg-green-700 block md:hidden focus:outline-none"
            style={contactButtonMobile}
            data-testid="report-an-issue-btn-mobile"
        >
            <span className="block text-3xl inline-block align-bottom">
                <FaEnvelope />
            </span>
        </button>
    </>
);

IssueFloatingButton.propTypes = {
    onClickHandler: PropTypes.func,
};

export default IssueFloatingButton;
